@if (!!value || showFieldAsEdit()) {
  <div class="field">
    <label class="upper">{{ displayName }}</label>
    <topo-phone-input
      [formControl]="control"
      [placeholder]="displayName"
      size="sm"
      (blur)="handleBlur()"
      [showErrorState]="blurredOnce && control.invalid" />
  </div>
}
